import { render, staticRenderFns } from "./merchant-charts.vue?vue&type=template&id=70ee439f&scoped=true"
import script from "./merchant-charts.vue?vue&type=script&lang=js"
export * from "./merchant-charts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee439f",
  null
  
)

export default component.exports